import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { pendingDopApprovals } from "../../../api/apiServices";
import Pagination from '../../../services/Pagination'

const DopApprovals = () => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const params = useParams();
    const id = params.id ? params.id : undefined

    const [applications, setApplications] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(15);


    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        pendingDopApprovals({ signal })
            .then((data) => {
                setApplications(data)
            });
        return () => {
            controller.abort();
        };
    }, [currentPage])

    const indexOfLastPage = currentPage * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPosts = applications?.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <section className='main-container'>
            <div className="box-body">
                <h2 className="heading">DOP - Pending Applications</h2>
                {currentPosts && currentPosts.length <= 0 ? (
                    <table className="table table-bordered">
                        <tr>
                            <th style={{ fontSize: "16px", fontWeight: "700", color: "#fff", align: "left" }}>
                                No application(s) available for processing
                            </th>
                        </tr>
                    </table>
                ): (
                <><table className="table table-bordered">
                            <thead className="align">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Full NAME</th>
                                    <th scope="col">REGION</th>
                                    <th scope="col">MOBILE</th>
                                    <th scope="col">EMAIL</th>
                                    <th scope="col">QUALIFICATION</th>
                                    <th scope="col">ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPosts.map((mem, index) => (
                                    <tr key={index}>
                                        <td>{postPerPage * (currentPage - 1) + index + 1}</td>
                                        <td>{mem.title} {mem.last_name} {mem.first_name} {mem.Middle_name}</td>
                                        <td>{mem.region}</td>
                                        <td>{mem.mobile_number}</td>
                                        <td>{mem.email}</td>
                                        <td>{mem.qualification}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>
                                            <div style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
                                                <Link to={`/dop_approve_form/${mem.id}`} className="small">Approval</Link>
                                            </div>&nbsp;&nbsp;
                                            <div style={{ display: 'inline-block' }}>
                                                <Link to={`/view_member/${mem.id}`} className="small">View</Link>
                                            </div>&nbsp; &nbsp;
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </table><div style={{ float: "left" }}>
                                <Pagination
                                    data={applications}
                                    postPerPage={postPerPage}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setPostPerPage={setPostPerPage} />
                            </div></>

                )}
            </div>
        </section>
    );
}

export default DopApprovals;


